import { addDoc, collection } from "firebase/firestore";
import { db } from "./firebase";

export const PRESET_LOCATIONS = [];

export const CARD_DATA = [
  {name:"2026",hands:[
    {groups:[{t:"222",c:"g"},{t:"000",c:"b"},{t:"2222 6666",c:"r"}],value:"X 25"},
    {groups:[{t:"2026",c:"g"},{t:"DDD",c:"g"},{t:"2222 DDD",c:"r"}],value:"X 25"},
    {groups:[{t:"FFF",c:"b"},{t:"2026",c:"g"},{t:"222",c:"r"},{t:"6666",c:"b"}],value:"X 25"},
    {groups:[{t:"22",c:"g"},{t:"00",c:"b"},{t:"222 666",c:"r"},{t:"NEWS",c:"b"}],value:"X 30"},
  ]},
  {name:"2468",hands:[
    {groups:[{t:"222 444 6666 8888",c:"b"}],value:"X 25"},
    {groups:[{t:"222 444",c:"g"},{t:"6666 8888",c:"r"}],value:"X 25"},
    {groups:[{t:"FF",c:"b"},{t:"2222",c:"g"},{t:"44 66",c:"r"},{t:"8888",c:"g"}],value:"X 30"},
    {groups:[{t:"EE",c:"b"},{t:"22 444 666 88",c:"b"},{t:"WW",c:"b"}],value:"X 30"},
    {groups:[{t:"2222",c:"g"},{t:"DDD",c:"g"},{t:"8888 DDD",c:"r"}],value:"X 25"},
    {groups:[{t:"FFF",c:"b"},{t:"22 44 666 8888",c:"b"}],value:"X 25"},
    {groups:[{t:"2468",c:"g"},{t:"2222",c:"r"},{t:"D",c:"r"},{t:"2222 D",c:"b"}],value:"X 25"},
    {groups:[{t:"FFF",c:"b"},{t:"2468",c:"g"},{t:"FFF",c:"b"},{t:"2222",c:"r"}],value:"X 30"},
    {groups:[{t:"FF",c:"b"},{t:"246 888",c:"g"},{t:"246 888",c:"r"}],value:"C 30"},
  ]},
  {name:"ANY LIKE NUMBERS",hands:[
    {groups:[{t:"1111",c:"g"},{t:"FFFFFF",c:"b"},{t:"1111",c:"r"}],value:"X 30"},
    {groups:[{t:"1111 D",c:"g"},{t:"111 D",c:"r"},{t:"1111 D",c:"b"}],value:"X 25"},
    {groups:[{t:"FF",c:"b"},{t:"1111",c:"g"},{t:"11",c:"r"},{t:"1111",c:"b"},{t:"DD",c:"g"}],value:"X 25"},
  ]},
  {name:"QUINTS",hands:[
    {groups:[{t:"11111",c:"g"},{t:"1111",c:"r"},{t:"11111",c:"b"}],value:"X 40"},
    {groups:[{t:"FF",c:"b"},{t:"11111 22 33333",c:"b"}],value:"X 45"},
    {groups:[{t:"11111 44444",c:"g"},{t:"DDDD",c:"r"}],value:"X 40"},
  ]},
  {name:"CONSECUTIVE RUN",hands:[
    {groups:[{t:"11 222 33 444 5555",c:"b"}],value:"X 25"},
    {groups:[{t:"55 666 77 888 9999",c:"b"}],value:"X 25"},
    {groups:[{t:"FFF",c:"b"},{t:"1111 234 5555",c:"b"}],value:"X 25"},
    {groups:[{t:"FFF",c:"b"},{t:"1111",c:"g"},{t:"234",c:"r"},{t:"5555",c:"g"}],value:"X 25"},
    {groups:[{t:"11 22",c:"g"},{t:"111 222",c:"r"},{t:"3333",c:"b"}],value:"X 25"},
    {groups:[{t:"111 222 3333 4444",c:"b"}],value:"X 25"},
    {groups:[{t:"111 222",c:"g"},{t:"3333 4444",c:"r"}],value:"X 25"},
    {groups:[{t:"FFF 11 22 333 DDDD",c:"b"}],value:"X 30"},
    {groups:[{t:"FFF",c:"b"},{t:"11",c:"g"},{t:"22",c:"r"},{t:"333",c:"g"},{t:"DDDD",c:"r"}],value:"X 30"},
    {groups:[{t:"1111 FFFFFF 2222",c:"b"}],value:"X 30"},
    {groups:[{t:"FF 1111 2222 3333",c:"b"}],value:"X 25"},
    {groups:[{t:"FF",c:"b"},{t:"1111",c:"g"},{t:"2222",c:"r"},{t:"3333",c:"b"}],value:"X 25"},
    {groups:[{t:"1 22 333",c:"g"},{t:"1 22 333",c:"r"},{t:"44",c:"b"}],value:"C 35"},
  ]},
  {name:"13579",hands:[
    {groups:[{t:"11 333 55 777 9999",c:"b"}],value:"X 25"},
    {groups:[{t:"11 333",c:"g"},{t:"55 777",c:"r"},{t:"9999",c:"b"}],value:"X 25"},
    {groups:[{t:"111 333",c:"g"},{t:"3333 5555",c:"r"}],value:"X 25"},
    {groups:[{t:"555 777",c:"g"},{t:"7777 9999",c:"r"}],value:"X 25"},
    {groups:[{t:"NN",c:"b"},{t:"1111 33 5555",c:"b"},{t:"SS",c:"b"}],value:"X 30"},
    {groups:[{t:"NN",c:"b"},{t:"5555 77 9999",c:"b"},{t:"SS",c:"b"}],value:"X 30"},
    {groups:[{t:"113579",c:"g"},{t:"1111",c:"r"},{t:"1111",c:"b"}],value:"X 25"},
    {groups:[{t:"FFF",c:"b"},{t:"11 33 555",c:"b"},{t:"DDDD",c:"b"}],value:"X 25"},
    {groups:[{t:"FFF",c:"b"},{t:"55 77 999",c:"b"},{t:"DDDD",c:"b"}],value:"X 25"},
    {groups:[{t:"11 33",c:"g"},{t:"111 333",c:"r"},{t:"5555",c:"b"}],value:"X 25"},
    {groups:[{t:"55 77",c:"g"},{t:"555 777",c:"r"},{t:"9999",c:"b"}],value:"X 25"},
    {groups:[{t:"1111 33 55 77 9999",c:"b"}],value:"X 30"},
    {groups:[{t:"1111",c:"g"},{t:"33 55 77",c:"r"},{t:"9999",c:"g"}],value:"X 30"},
    {groups:[{t:"FF",c:"b"},{t:"11 33 55",c:"g"},{t:"111",c:"r"},{t:"111",c:"b"}],value:"C 35"},
    {groups:[{t:"FF",c:"b"},{t:"55 77 99",c:"g"},{t:"555",c:"r"},{t:"555",c:"b"}],value:"C 35"},
    {groups:[{t:"FF",c:"b"},{t:"135 777 999",c:"g"},{t:"DDD",c:"r"}],value:"C 30"},
  ]},
  {name:"WINDS \u2013 DRAGONS",hands:[
    {groups:[{t:"NNNN EEE WWW SSSS",c:"b"}],value:"X 25"},
    {groups:[{t:"NNN EEEE WWWW SSS",c:"b"}],value:"X 25"},
    {groups:[{t:"1234",c:"b"},{t:"DDD",c:"g"},{t:"DDD",c:"r"},{t:"DDDD",c:"b"}],value:"X 25"},
    {groups:[{t:"NNN",c:"b"},{t:"1111",c:"g"},{t:"1111",c:"r"},{t:"SSS",c:"b"}],value:"X 25"},
    {groups:[{t:"EEE",c:"b"},{t:"2222",c:"g"},{t:"2222",c:"r"},{t:"WWW",c:"b"}],value:"X 25"},
    {groups:[{t:"FFF",c:"b"},{t:"NNNN",c:"b"},{t:"FFF",c:"b"},{t:"DDDD",c:"b"}],value:"X 25"},
    {groups:[{t:"1 N 2 EE 3 WWW 4 SSSS",c:"b"}],value:"X 25"},
    {groups:[{t:"FF NNNN SSSS",c:"b"},{t:"DD",c:"g"},{t:"DD",c:"r"}],value:"X 25"},
    {groups:[{t:"FF",c:"b"},{t:"EEEE WWWW",c:"b"},{t:"DD",c:"g"},{t:"DD",c:"r"}],value:"X 25"},
    {groups:[{t:"NN EEE",c:"b"},{t:"2026",c:"b"},{t:"WWW SS",c:"b"}],value:"C 30"},
  ]},
  {name:"369",hands:[
    {groups:[{t:"333 666",c:"g"},{t:"6666 9999",c:"r"}],value:"X 25"},
    {groups:[{t:"333 666",c:"g"},{t:"6666",c:"r"},{t:"9999",c:"b"}],value:"X 25"},
    {groups:[{t:"33 66",c:"g"},{t:"333 666",c:"r"},{t:"9999",c:"b"}],value:"X 25"},
    {groups:[{t:"FFF",c:"b"},{t:"33 666 99",c:"b"},{t:"DDDD",c:"b"}],value:"X 25"},
    {groups:[{t:"FFF",c:"b"},{t:"33 666 99",c:"g"},{t:"DDDD",c:"r"}],value:"X 25"},
    {groups:[{t:"33 66",c:"g"},{t:"666 999",c:"r"},{t:"NEWS",c:"b"}],value:"X 30"},
    {groups:[{t:"FF",c:"b"},{t:"3369",c:"g"},{t:"3333",c:"r"},{t:"3333",c:"b"}],value:"X 25"},
    {groups:[{t:"FF",c:"b"},{t:"333 666 999",c:"g"},{t:"369",c:"r"}],value:"C 30"},
  ]},
  {name:"SINGLES AND PAIRS",hands:[
    {groups:[{t:"NN EE WW SS",c:"b"},{t:"1D",c:"g"},{t:"1D",c:"r"},{t:"1D",c:"b"}],value:"C 50"},
    {groups:[{t:"2 4 66 88",c:"g"},{t:"2 4 66 88",c:"r"},{t:"88",c:"b"}],value:"C 50"},
    {groups:[{t:"FF",c:"b"},{t:"3369",c:"g"},{t:"3669",c:"r"},{t:"3699",c:"b"}],value:"C 50"},
    {groups:[{t:"11 22 33 44 55 66 77",c:"b"}],value:"C 50"},
    {groups:[{t:"11 357 99",c:"g"},{t:"11 357 99",c:"r"}],value:"C 50"},
    {groups:[{t:"FF",c:"b"},{t:"2026",c:"g"},{t:"2026",c:"r"},{t:"2026",c:"b"}],value:"C 75"},
  ]},
];

export const TOTAL_HANDS=72;
export const MILESTONES=[1,5,10,20,30,40,50,60,70,80,90,100];
export const MILESTONE_BADGES={
  1:{icon:"\u{1F338}",label:"You got your wings!"},
  5:{icon:"\u{1F423}",label:"Crak Baby"},
  10:{icon:"\u{1F3B2}",label:"On a Roll"},
  20:{icon:"\u{1F525}",label:"Hot Hand"},
  30:{icon:"\u{1F409}",label:"Dragon Slayer"},
  40:{icon:"\u{1F355}",label:"Halfway to Mahj-ic"},
  50:{icon:"\u{1F485}",label:"Mahj-esty"},
  60:{icon:"\u{1F32C}\uFE0F",label:"Wind Beneath My Tiles"},
  70:{icon:"\u{1F985}",label:"Lady Bird Legend"},
  80:{icon:"\u{1F624}",label:"One Tile Away from Therapy"},
  90:{icon:"\u{1F680}",label:"So Close You Can Taste It"},
  100:{icon:"\u{1F451}",label:"Grand Mahj-ster"},
};

export const FRIENDLY_ERRORS={"auth/invalid-credential":"Incorrect email or password.","auth/user-not-found":"No account with that email.","auth/wrong-password":"Incorrect password.","auth/email-already-in-use":"An account with that email already exists.","auth/weak-password":"Password must be at least 6 characters.","auth/invalid-email":"That doesn't look like a valid email.","auth/too-many-requests":"Too many attempts. Wait a minute."};
export const friendlyError=(e)=>FRIENDLY_ERRORS[e?.code]||"Something went wrong. Try again.";
export const shareMilestone=(badge,pct)=>{const msg=pct===1?`I just earned ${badge.icon} ${badge.label} on MahjSpace \u2014 my first hand of the 2026 card! Start charting your progress: mahjspace.com`:`I just earned ${badge.icon} ${badge.label} on MahjSpace \u2014 ${pct}% of 2026 card completed! Start charting your progress: mahjspace.com`;if(navigator.share)navigator.share({text:msg}).catch(()=>{});else{navigator.clipboard?.writeText(msg);alert("Copied to clipboard!");}};
export const sendEmail=async(to,subject,html)=>{try{await addDoc(collection(db,"mail"),{to,message:{subject,html}});}catch(e){console.error(e);}};

export const COLOR_MAP={r:"#E06060",g:"#4EAE6A",b:"#5A8ED8"};

// ----- Memory entries (multi-win) helpers -----
// Memory shape per hand is now an ARRAY of entries.
// Legacy single-object data is normalized on read so old saves keep working.
export const getEntries=(mem)=>{
  if(!mem)return[];
  if(Array.isArray(mem))return mem;
  return[{...mem,id:mem.id||"legacy"}];
};
// Sort newest first by date, then createdAt as tiebreaker.
export const sortEntries=(entries)=>{
  return[...entries].sort((a,b)=>{
    const ad=a.date||"";const bd=b.date||"";
    if(ad!==bd)return bd.localeCompare(ad);
    return(b.createdAt||0)-(a.createdAt||0);
  });
};
// Build a fresh entry with a unique id and createdAt stamp.
export const newEntry=(data)=>({
  id:Date.now().toString(36)+Math.random().toString(36).slice(2,5),
  createdAt:Date.now(),
  ...data,
});
// Pick the most recent entry to summarize the row when only single-detail view is needed.
export const latestEntry=(mem)=>{
  const arr=sortEntries(getEntries(mem));
  return arr[0]||null;
};
// Aggregate status across all entries: "confirmed" if any confirmed, else "pending" if any
// pending, else "unverified" if any unverified, else null.
export const aggregateStatus=(mem)=>{
  const arr=getEntries(mem);
  if(!arr.length)return null;
  if(arr.some(e=>e.status==="confirmed"))return"confirmed";
  if(arr.some(e=>e.status==="pending"))return"pending";
  if(arr.some(e=>e.status==="unverified"))return"unverified";
  return null;
};
